import React, { useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { Button, Link } from "@mui/material";
import { useAppSelector } from "../../app/hooks";

/* Functional component properties */
interface Props {
  isOpen: boolean;
  handleDialogClose: () => void;
  handler: (button: any) => void;
  classes: any;
}

/* React Functional component */
export const DialogRenderer: React.FC<Props> = ({
  /* Function arguments (Props) */
  isOpen,
  handleDialogClose,
  handler,
  classes,
}): JSX.Element => {
  /* get state */
  const state = useAppSelector((state) => state);

  const [open, setOpen] = React.useState(false);

  const openInNewTab = (url: string) => {
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };

  useEffect(() => {
    setOpen(isOpen);
  }, [isOpen]);

  const handleClick = (action: string | undefined) => {
    handleDialogClose();

    if (action !== undefined && action.localeCompare("DISMISS") !== 0)
      handler({ name: action });
  };

  return (
    /* Dialog box rendering for menu options click */
    // <DialogStyle>
    <Dialog
      onClose={handleDialogClose}
      open={open}
      maxWidth={"lg"}
      className={classes.contactCard}
    >
      <DialogTitle
      // disableTypography
      // className={
      //   state.mainContent.dialogPopUp.header &&
      //   state.mainContent.dialogPopUp.header === "Error"
      //     ? classes.errorDialog
      //     : ""
      // }
      >
        {state.mainContent.dialogPopUp.header
          ? state.mainContent.dialogPopUp.header
          : ""}
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={handleDialogClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        {state.mainContent.dialogPopUp.content &&
        typeof state.mainContent.dialogPopUp.content === "object"
          ? Object.keys(state.mainContent.dialogPopUp.content).map(
              (attr: string, idx: number) => (
                <span key={"Dialog" + idx}>
                  {(() => {
                    switch (true) {
                      case attr === "url":
                        if (state.mainContent.dialogPopUp.content.url !== "")
                          return (
                            <Link
                              component="a"
                              href="#"
                              onClick={() =>
                                openInNewTab(
                                  state.mainContent.dialogPopUp.content.url ||
                                    ""
                                )
                              }
                            >
                              {state.mainContent.dialogPopUp.content.url}
                              <br />
                              <br />
                            </Link>
                          );
                        else return "";

                      case typeof state.mainContent.dialogPopUp.content[
                        attr as keyof typeof state.mainContent.dialogPopUp.content
                      ] === "object":
                        const arr: [string, string][] = Object.entries(
                          state.mainContent.dialogPopUp.content[
                            attr as keyof typeof state.mainContent.dialogPopUp.content
                          ]!
                        );

                        return arr.map((data) => (
                          <div
                            key={attr + data[0] + "Dialog"}
                            className={
                              state.mainContent.dialogPopUp.header &&
                              state.mainContent.dialogPopUp.header === "Error"
                                ? classes.errorDialog
                                : ""
                            }
                          >
                            <strong>{data[0]}</strong> : {data[1]}
                            <br />
                            <br />
                          </div>
                        ));

                      default:
                        if (
                          state.mainContent.dialogPopUp.content[
                            attr as keyof typeof state.mainContent.dialogPopUp.content
                          ]
                            ?.toString()
                            .trim() !== ""
                        )
                          return (
                            <div key={attr + "Dialog"}>
                              {state.mainContent.dialogPopUp.content[
                                attr as keyof typeof state.mainContent.dialogPopUp.content
                              ]?.toString()}
                              <br />
                              <br />
                            </div>
                          );
                        else return "";
                    }
                  })()}
                </span>
              )
            )
          : state.mainContent.dialogPopUp.content}
      </DialogContent>
      {state.mainContent.dialogPopUp.action &&
      state.mainContent.dialogPopUp.action.length ? (
        <DialogActions>
          {state.mainContent.dialogPopUp.action.map((action) => (
            <Button
              key={action + "DialogAction"}
              className={classes.indvButton}
              autoFocus
              onClick={() => handleClick(action)}
              color="primary"
            >
              {action}
            </Button>
          ))}
        </DialogActions>
      ) : (
        ""
      )}
    </Dialog>
    // </DialogStyle>
  );
};
